import { AValueComponent } from "../AValueComponent";
import { ValueChangerController } from "../ValueChangerController";
import { AValueWrapper } from "./AValueWrapper";

export class StrictStepWrapper extends AValueWrapper {
    private _step: number;

    constructor(parent: ValueChangerController, minValue: number, maxValue: number, wrapTarget: AValueComponent, step: number) {
        super(parent, minValue, maxValue, wrapTarget);

        this._step = step;
    }

    protected wrappedUpdateByUserChanges(newValue: number): void {
        let newWrappedValue: number = newValue;
        if (newValue != this.maxValue) {
            if (Number(newValue / this._step) != newValue / this._step) {
                let div: number = newValue - this.value;
                let _valueStep: number = this.value / this._step;

                if (div > 0) {
                    newWrappedValue = (Number(_valueStep) + 1) * this._step;
                }
                else {
                    if (_valueStep != Number(_valueStep)) {
                        newWrappedValue = (Number(_valueStep)) * this._step;
                    }
                    else {
                        newWrappedValue = (Number(_valueStep) - 1) * this._step;
                    }
                }
            }
        }

        super.wrappedUpdateByUserChanges(newWrappedValue);
    }
}
